import { Action, createAction, handleActions } from "redux-actions";
import { queueMessage } from "~shared/snackbarsProvider/actions";
import fileService from "~libs/fileService";

/** Archivo elegido en una de las tres cajas de subida. */
export interface ArchivoSeleccionado {
  value: string | null;
  valid: boolean;
}

export interface SubidaArchivosInfoautoState {
  tautos30FileNameSelected: ArchivoSeleccionado | null;
  extradFileNameSelected: ArchivoSeleccionado | null;
  gruposFileNameSelected: ArchivoSeleccionado | null;
  archivosSubidos: boolean;
}

export interface MoveArchivosInfoautoData {
  sourceBucket?: string;
  tautos30Filename: string | null;
  extradFilename: string | null;
  gruposFilename: string | null;
  destBucket?: string;
}

const subidaArchivosInfoautoInitialState: SubidaArchivosInfoautoState = {
  tautos30FileNameSelected: null,
  extradFileNameSelected: null,
  gruposFileNameSelected: null,
  archivosSubidos: false,
};

const setTautos30FileName = createAction(
  "SET_TAUTOS30_FILENAME",
  (tautos30FileNameSelected: ArchivoSeleccionado) => ({
    tautos30FileNameSelected,
  })
);

const setExtradFileName = createAction(
  "SET_EXTRAD_FILENAME",
  (extradFileNameSelected: ArchivoSeleccionado) => ({
    extradFileNameSelected,
  })
);

const setGruposFileName = createAction(
  "SET_GRUPOS_FILENAME",
  (gruposFileNameSelected: ArchivoSeleccionado) => ({
    gruposFileNameSelected,
  })
);

const setSubmitting = createAction("SET_SUBMITTING", (submitting: boolean) => ({
  submitting,
}));

const moveArchivosInfoauto = (data: MoveArchivosInfoautoData) => {
  return async (dispatch: (action: any) => void) => {
    try {
      dispatch(uploadArchivosInfoautoInited());

      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear();
      let suffixFilename = `${yyyy}-${mm}-${dd}`;

      const fileServiceToMove = fileService("");
      await fileServiceToMove.copy(
        `${data.sourceBucket}/${data.tautos30Filename}`,
        data.destBucket,
        `${suffixFilename}-tautos30.dbf`
      );

      await fileServiceToMove.copy(
        `${data.sourceBucket}/${data.extradFilename}`,
        data.destBucket,
        `${suffixFilename}-extrad.dbf`
      );

      await fileServiceToMove.copy(
        `${data.sourceBucket}/${data.gruposFilename}`,
        data.destBucket,
        `${suffixFilename}-grupos.dbf`
      );

      dispatch(uploadArchivosInfoautoCompleted());
    } catch (error) {
      dispatch(uploadArchivosInfoautoFailed(error));
      dispatch(
        queueMessage(
          "Ocurrió un error al subir los archivos. Intente nuevamente."
        )
      );
    }
  };
};

const uploadArchivosInfoautoInited = createAction(
  "UPLOAD_ARCHIVOS_INFOAUTO_INITED"
);

const uploadArchivosInfoautoCompleted = createAction(
  "UPLOAD_ARCHIVOS_INFOAUTO_COMPLETED"
);

const uploadArchivosInfoautoFailed = createAction(
  "UPLOAD_ARCHIVOS_INFOAUTO_FAILED",
  (error: unknown) => ({
    error,
  })
);

const subidaArchivosInfoautoReducer = handleActions<
  SubidaArchivosInfoautoState,
  any
>(
  {
    [setTautos30FileName.toString()]: (
      state: SubidaArchivosInfoautoState,
      action: Action<{ tautos30FileNameSelected: ArchivoSeleccionado }>
    ): SubidaArchivosInfoautoState => {
      return {
        ...state,
        tautos30FileNameSelected: action.payload.tautos30FileNameSelected,
      };
    },
    [setExtradFileName.toString()]: (
      state: SubidaArchivosInfoautoState,
      action: Action<{ extradFileNameSelected: ArchivoSeleccionado }>
    ): SubidaArchivosInfoautoState => {
      return {
        ...state,
        extradFileNameSelected: action.payload.extradFileNameSelected,
      };
    },
    [setGruposFileName.toString()]: (
      state: SubidaArchivosInfoautoState,
      action: Action<{ gruposFileNameSelected: ArchivoSeleccionado }>
    ): SubidaArchivosInfoautoState => {
      return {
        ...state,
        gruposFileNameSelected: action.payload.gruposFileNameSelected,
      };
    },
    [uploadArchivosInfoautoInited.toString()]: (
      state: SubidaArchivosInfoautoState
    ): SubidaArchivosInfoautoState => {
      return {
        ...state,
      };
    },
    [uploadArchivosInfoautoCompleted.toString()]: (
      state: SubidaArchivosInfoautoState
    ): SubidaArchivosInfoautoState => {
      return {
        ...state,
        archivosSubidos: true,
      };
    },
    [uploadArchivosInfoautoFailed.toString()]: (
      state: SubidaArchivosInfoautoState
    ): SubidaArchivosInfoautoState => {
      return {
        ...state,
      };
    },
  },
  subidaArchivosInfoautoInitialState
);

export {
  subidaArchivosInfoautoReducer,
  setTautos30FileName,
  setExtradFileName,
  setGruposFileName,
  setSubmitting,
  moveArchivosInfoauto as moveArchivosInfoautoFinalDest,
};
